import { useEffect, useState } from "react";
import { Plus } from "lucide-react";
import { Link } from "react-router-dom";
import DashboardLayout from "../../components/layouts/DashboardLayout";
import _ from "lodash";
import CampaignCard from "../../components/layouts/CampaignCard";
import axios from "axios";
import { message } from "../../utils/toast";
import { SERVER_URL } from "../../utils/config";

const CampaignsListPage = () => {
  const [campaignList, setCampaignList] = useState([]);
  useEffect(() => {
    axios
      .get(`${SERVER_URL}/api/campaign`)
      .then(({ data }) => {
        setCampaignList(data);
      })
      .catch((error) => {
        message({ type: "error", content: error.message });
      });
  }, []);

  return (
    <DashboardLayout>
      <div className="p-8">
        <div className="flex justify-between items-center mb-8 max-md:block">
          <div className="max-md:mb-4">
            <h1 className="text-2xl font-bold text-gray-900">Campaigns</h1>
            <p className="text-gray-600">
              Manage and track your landing page campaigns
            </p>
          </div>
          <Link
            to="/new-campagin"
            className="inline-flex items-center gap-2 bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 max-md:flex max-md:justify-center"
          >
            <Plus size={20} />
            New Campaign
          </Link>
        </div>

        <div className="grid grid-cols-2 gap-6 max-md:grid-cols-1">
          {_.map(campaignList, (campaign) => (
            <CampaignCard key={campaign.id} {...campaign} />
          ))}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default CampaignsListPage;
